import React,{useState} from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { ForgretPassword } from '../../Data';

const ForgetPass = () => {
    const [email, setEmail] = useState("")
    const navigate = useNavigate();

    const handleSubmit = () => {
        ForgretPassword(email).then((response) => {
            if (response.ok) {
              setEmail("");
              toast.success("Kindly Check your email");
              navigate("/Reset-Password")
            } else {
              toast.error("This email does not exist, please register");
            }
          });
    }
  return (
    <>
    <div className="container mt-5">
    <div className="breadcrumb-area mb-5">
				<div className="container">
					<div className="row">
						<div className="col">
							<div className="breadcrumb-container HomeShop">
								<ul>
									<li><a href="index.html"><i className="fa fa-home"></i> Home</a></li>
									<li className="active">Forget Password</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
        <div className="row justify-content-center">
            <div className="col-12 col-md-8">
                <div className="authenticationCard">
                    <div className="row topBar">
                        <div className="col-12 text-center">
                            {/* <button className='active'>Forget Password</button> */}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12 col-md-2"><label>Email:</label></div>
                        <div className="col-12 col-md-10">
                            <input className="form-control" placeholder="Type Here" required onChange={(e) => setEmail(e.target.value)}></input>
                        </div>
                    </div>
                    <div className="row mb-3 submit">
                        <div className="col-12 text-center">
                            <button className="Resend-button mt-0" onClick={(e) => handleSubmit(e)}>Send Code</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</>
  )
}

export default ForgetPass